import { api } from "@/services/Api";

export interface CrmStoreState {
  // Tags
  tags: any[];
  tagsLoading: boolean;
  tagsLoaded: boolean;
  tagsLoadPromise: Promise<any[]> | null;
}

const crmStore = {
  namespaced: true,
  state: (): CrmStoreState => ({
    tags: [],
    tagsLoading: false,
    tagsLoaded: false,
    tagsLoadPromise: null,
  }),
  getters: {
    tags: (state: CrmStoreState) => state.tags,
    tagsLoading: (state: CrmStoreState) => state.tagsLoading,
    tagsLoaded: (state: CrmStoreState) => state.tagsLoaded,
  },
  mutations: {
    SET_TAGS(state: CrmStoreState, tags: any[]) {
      state.tags = tags;
      state.tagsLoaded = true;
    },
    SET_TAGS_LOADING(state: CrmStoreState, loading: boolean) {
      state.tagsLoading = loading;
    },
    SET_TAGS_LOAD_PROMISE(state: CrmStoreState, promise: Promise<any[]> | null) {
      state.tagsLoadPromise = promise;
    },
    ADD_TAG(state: CrmStoreState, tag: any) {
      state.tags.push(tag);
    },
  },
  actions: {
    async loadTags({ state, commit }: any): Promise<any[]> {
      if (state.tagsLoaded) {
        return state.tags;
      }
      if (state.tagsLoadPromise) {
        return state.tagsLoadPromise;
      }
      const promise = (async () => {
        commit("SET_TAGS_LOADING", true);
        try {
          const res = await api.get(api.crm, "tag/list");
          let tags: any[] = [];
          if (res?.data?.tags) {
            tags = res.data.tags;
          } else if (res?.data && Array.isArray(res.data)) {
            tags = res.data;
          }
          commit("SET_TAGS", tags);
          return tags;
        } catch (error) {
          console.error("Error loading CRM tags:", error);
          return [];
        } finally {
          commit("SET_TAGS_LOADING", false);
          commit("SET_TAGS_LOAD_PROMISE", null);
        }
      })();
      commit("SET_TAGS_LOAD_PROMISE", promise);
      return promise;
    },
    async createTag({ commit }: any, label: string): Promise<any | null> {
      try {
        const res = await api.post(api.crm, "tag/create", { label });
        if (res?.data?.type) {
          commit("ADD_TAG", res.data.type);
          return res.data.type;
        }
      } catch (e) {
        console.error("Error creating CRM tag:", e);
      }
      return null;
    },
    reloadTags({ state, commit, dispatch }: any) {
      state.tagsLoaded = false;
      commit("SET_TAGS_LOAD_PROMISE", null);
      return dispatch("loadTags");
    },
  },
};

export default crmStore;
